import React from "react";
import { DictionaryProperties } from "../property-creators/dictionary-properties";
import { LabelProperties } from "../property-creators/label-properties";
import s from "./index.module.css";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { NumberProperties } from "../property-creators/number-properties";
import { TextProperties } from "../property-creators/text-properties";
import { FileProperties } from "../property-creators/file-properties";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

// Use inline styles for size so the output is self-describing
// (works in mobile/RN without Quill stylesheet).
const SizeStyle = Quill.import("attributors/style/size");
SizeStyle.whitelist = ["0.75em", "1.25em", "1.5em", "1.75em"];
Quill.register(SizeStyle, true);

// model:
// const sampleModel = {
//   size: 10,
//   text: 'laksdjflksdjf',
//   alignment: 'left',
//   fontSize: '20px',
//   bold: true,
//   italic: false,
//   label: 'some label',
//   labelPosition: 'left',
//   required: true,
//   border: true,
//   header: 'some header',
// }

const quillColors = [
  // Row 1 — lightest (white + Material 100)
  "#ffffff", "#ffcdd2", "#ffe0b2", "#fff9c4", "#c8e6c9", "#bbdefb", "#e1bee7",
  // Row 2 — light (Material 300)
  "#e0e0e0", "#e57373", "#ffb74d", "#fff176", "#81c784", "#64b5f6", "#ba68c8",
  // Row 3 — default (Material 500)
  "#9e9e9e", "#f44336", "#ff9800", "#ffeb3b", "#4caf50", "#2196f3", "#9c27b0",
  // Row 4 — dark (Material 700)
  "#616161", "#d32f2f", "#f57c00", "#fbc02d", "#388e3c", "#1976d2", "#7b1fa2",
  // Row 5 — darkest (black + Material 900)
  "#000000", "#b71c1c", "#e65100", "#f57f17", "#1b5e20", "#0d47a1", "#4a148c",
];

const quillModules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ size: ["0.75em", false, "1.25em", "1.5em", "1.75em"] }],
    [{ color: quillColors }],
    ["clean"],
  ],
};

const quillFormats = ["bold", "italic", "underline", "size", "color"];

export const defaultState = {
  size: "100",
  text: "",
  alignment: "left",
  fontSize: "20",
  bold: false,
  italic: false,
  label: "",
  richText: false,
  labelPosition: "left",
  required: false,
  noteEnabled: false,
  border: false,
  header: "",
  showInTableView: false,
  maxRows: "1",
};

const getDataTypeText = (dataType) => {
  switch (dataType) {
    case "TEXT":
      return "pole tekstowe";
    case "TEXTAREA":
      return "pole tekstowe";
    case "NUMBER":
      return "pole liczbowe";
    case "FILE":
      return "plik";
    case "SIGN":
      return "podpis";
    case "LOCATION":
      return "lokalizacja";
    case "DICTIONARY":
      return "słownik";
    case "TIME":
      return "czas";
    case "DATE":
      return "data";
    case "DATETIME":
      return "data i czas";
    case "GROUP":
      return "grupa";
    case "REPEATING_GROUP":
      return "grupa";
    case "BOOL":
      return "prawda/fałsz";
    case "PESEL":
      return "pesel";
    case "QRCODE":
      return "kod QR";
    case "LABEL":
      return "etykieta";
  }
};

const ControlProperties = ({
  displayMode,
  controlId,
  dataType,
  configuration = {},
  update,
  formEdited,
  addMode,
}) => {
  const disabled = ""; //configuration ? "" : "disabled"

  // Lift-state-up: this component holds NO local state for configuration
  // fields. Every change is sent straight to the parent via `update`,
  // which merges the partial change into selectedItem.configuration.
  //
  // Why no local state?
  //   Previously this component mirrored configuration props into a local
  //   useState and synced back via a `useEffect(() => update(state), [state])`.
  //   That cycle worked with plain inputs but broke with self-triggering
  //   components like ReactQuill (which fires onChange on mount/normalization),
  //   producing infinite render loops. It also caused stale-content bugs when
  //   switching between questions because the local state lagged behind props.
  //
  // `values` is the merged view used by both this component's JSX and the
  // property-creator children. We spread defaultState first so children that
  // expect every default field present (e.g. NumberProperties reading
  // numberType) keep working.
  const values = { ...defaultState, ...configuration };

  // Helper for partial updates. We re-spread defaultState + configuration on
  // every call so the parent's merge produces the same shape the children
  // would otherwise produce themselves via `{...this.props.values, ...changes}`.
  // This preserves the prior behavior of "defaults get applied to the saved
  // configuration once the user touches the question".
  const updateConfig = (changes) =>
    update({ ...defaultState, ...configuration, ...changes });

  const dataTypeText = getDataTypeText(dataType);

  return (
    <div className={s.scroll}>
      <p className="menu-label">Właściwości</p>

      {
        <ul>
          {/*<li>*/}
          {/*  Maksymalna długość:*/}
          {/*  <input*/}
          {/*    disabled={disabled} type="number"*/}
          {/*    className="input is-small"*/}
          {/*    value={state.size}*/}
          {/*    onChange={({target: {value: size}}) => setState(*/}
          {/*      {...state, size})}/>*/}
          {/*</li>*/}

          {/*<li>*/}
          {/*  Położenie:*/}
          {/*  <input*/}
          {/*    disabled={disabled} type="text"*/}
          {/*    className="input is-small"*/}
          {/*    value={state.alignment}*/}
          {/*    onChange={({target: {value: alignment}}) => setState({...state, alignment})}/>*/}
          {/*</li>*/}
          {/*<li>*/}
          {/*  Rozmiar czcionki:*/}
          {/*  <input disabled={disabled} type="number"*/}
          {/*         className="input is-small"*/}
          {/*         value={state.fontSize}*/}
          {/*         onChange={({target: {value: fontSize}}) => setState({...state, fontSize})}/>*/}
          {/*</li>*/}
          <li>
            Typ: {dataTypeText}
            {typeof values.dictionary !== "undefined" &&
              values.dictionary !== null &&
              ` typu tekstowego`}
          </li>
          <li>
            Etykieta:
            {values.richText && !(disabled || displayMode) ? (
              // RISKY: ReactQuill is now controlled (`value=` instead of
              // `defaultValue=`). The `key={controlId}` forces a remount when
              // switching questions, which guarantees the editor reinitializes
              // with the new label. The `source !== "user"` guard is still
              // required because Quill fires onChange with source='api' during
              // its own normalization, and we must not loop those edits back.
              <ReactQuill
                key={controlId}
                value={values.label || ""}
                onChange={(value, delta, source) => {
                  if (source !== "user") return;
                  const isEmpty =
                    !value ||
                    value === "<p><br></p>" ||
                    value.replace(/<[^>]*>/g, "").trim() === "";
                  updateConfig({ label: isEmpty ? "" : value });
                }}
                modules={quillModules}
                formats={quillFormats}
                theme="snow"
              />
            ) : (
              <input
                disabled={disabled || displayMode}
                type="text"
                className="input is-small"
                value={values.label || ""}
                onChange={({ target: { value: label } }) =>
                  updateConfig({ label })
                }
              />
            )}
          </li>
          <li>
            <FormControlLabel
              disabled={displayMode}
              control={
                <Checkbox
                  checked={values.richText || false}
                  onChange={({ target: { checked: richText } }) =>
                    updateConfig({ richText })
                  }
                  color="primary"
                />
              }
              label="Rich text"
            />
          </li>
          <li>
            Podpowiedź:
            <input
              disabled={disabled || displayMode}
              type="text"
              className="input is-small"
              value={values.text || ""}
              onChange={({ target: { value: text } }) => updateConfig({ text })}
            />
          </li>
          <li>
            <FormControlLabel
              disabled={displayMode}
              control={
                <Checkbox
                  checked={values.required || false}
                  onChange={({ target: { checked: required } }) =>
                    updateConfig({ required })
                  }
                  name="checkedB"
                  color="primary"
                />
              }
              label="Pole wymagane"
            />
          </li>
          <li>
            <FormControlLabel
              disabled={displayMode}
              control={
                <Checkbox
                  checked={values.noteEnabled || false}
                  onChange={({ target: { checked: noteEnabled } }) =>
                    updateConfig({ noteEnabled })
                  }
                  name="checkedB"
                  color="primary"
                />
              }
              label="Notatka przy polu"
            />
          </li>
          <li>
            <FormControlLabel
              disabled={displayMode}
              control={
                <Checkbox
                  checked={values.showInTableView || false}
                  onChange={({ target: { checked: showInTableView } }) =>
                    updateConfig({ showInTableView })
                  }
                  name="checkedB"
                  color="primary"
                />
              }
              label="Wartość na liście wyników ogólnych"
            />
          </li>

          {/*
            RISKY: children now receive `values={values}` (= defaultState +
            configuration) and `setValues={update}` directly. They internally
            do `setValues({ ...this.props.values, ...changes })`, which will
            call our parent's `update(...)` with the merged shape — exactly
            what they used to send when `setValues` was the local `setState`.
            The parent's `originalUpdateSelectedItemConfiguration` already
            does `{ ...item.configuration, ...conf }`, so a partial conf is
            also fine if anything ever changes here.
          */}
          {dataType === "DICTIONARY" && (
            <DictionaryProperties
              displayMode={displayMode}
              values={values}
              setValues={update}
              formEdited={formEdited}
              addMode={addMode}
            />
          )}
          {dataType === "LABEL" && (
            <LabelProperties
              displayMode={displayMode}
              values={values}
              setValues={update}
            />
          )}
          {dataType === "NUMBER" && (
            <NumberProperties
              displayMode={displayMode}
              values={values}
              setValues={update}
              formEdited={formEdited}
            />
          )}

          {dataType === "TEXT" && (
            <TextProperties
              displayMode={displayMode}
              values={values}
              setValues={update}
              formEdited={formEdited}
            />
          )}

          {dataType === "FILE" && (
            <FileProperties
              displayMode={displayMode}
              values={values}
              setValues={update}
              formEdited={formEdited}
            />
          )}
          {/*{propertyCreators && propertyCreators({values: state, setValues: setState})}*/}

          {/* <li>
              Nagłówek:
              <input disabled={disabled} type="text"
                     className="input is-small"/>
            </li>
            <li>
              Położenie etykiety:
              <input disabled={disabled} type="text"
                     className="input is-small"/>
            </li>

            <li>
              <label className="checkbox">
                Wymagane <input disabled={disabled} type="checkbox"/>
              </label>
            </li>
            <li>
              <label className="checkbox">
                Ramka <input disabled={disabled} type="checkbox"/>
              </label>
            </li>
            <li>
              <label className="checkbox">
                Kursywa <input disabled={disabled} type="checkbox"/>
              </label>
            </li>
            <li>
              <label className="checkbox">
                Pogrubienie
                <input
                  disabled={disabled}
                  type="checkbox"
                  value={state.bold}
                  onChange={({target: {checked: bold}}) => setState({...state, bold})}/>
              </label>
            </li> */}
        </ul>
      }
    </div>
  );
};

export default ControlProperties;
